import { modelTypes } from 'constants'

function useSSR(models = []) {
	const props = models.reduce((acc, model) => {
		switch (model) {
			case modelTypes.initialState:
				// eslint-disable-next-line no-case-declarations
				const { currentPage, resources, routes, stores, properties } = window[model]

				// eslint-disable-next-line no-case-declarations
				const { contentBlocks } = properties

				return {
					...acc,
					currentPage,
					resources,
					routes,
					stores,

					// Todo: ask backends to fix this initialState
					contentBlocks,
				}

			case modelTypes.breadcrumbs:
				return { ...acc, breadcrumbs: window[model] }

			case modelTypes.productSpecificationOptions: {
				return {
					...acc,
					productSpecificationOptions: window[model],
				}
			}

			case modelTypes.currentCustomer: {
				return {
					...acc,
					currentCustomer: window[model] || {},
				}
			}

			case modelTypes.vendorPage: {
				const category = window[model].catalogProductsModel
				const rest = window[model]

				if (rest.catalogProductsModel) delete rest.catalogProductsModel

				return {
					...acc,
					...rest,
					...category,
				}
			}

			case modelTypes.resources: {
				return {
					...acc,
					resources: window[model],
				}
			}

			case modelTypes.productsByTag: {
				const { name, products, fullDescription } = window[model]

				return {
					...acc,
					results: name,
					products,
					fullDescription,
				}
			}

			case modelTypes.product: {
				return {
					...acc,
					product: { ...window.INITIAL_STATE?.currentPage?.product },
				}
			}

			case modelTypes.footer: {
				return {
					...acc,
					footer: { ...window[model] },
				}
			}

			case modelTypes.footerLinks: {
				return {
					...acc,
					footerLinks: { ...window[model] },
				}
			}

			case modelTypes.footerCopyright: {
				return {
					...acc,
					footerCopyright: { ...window[model] },
				}
			}

			case modelTypes.footerTopics: {
				return {
					...acc,
					footerTopics: [...window[model]],
				}
			}

			case modelTypes.socialSettings: {
				return {
					...acc,
					socialSettings: { ...window[model] },
				}
			}

			case modelTypes.newsletterSettings: {
				return {
					...acc,
					newsletterSettings: { ...window[model] },
				}
			}

			case modelTypes.criticalState:
				// eslint-disable-next-line no-case-declarations
				const { menu } = window[model]
				return { ...acc, menu }

			case modelTypes.searchPage: {
				const searchProps = {}
				searchProps.currentPage = {
					...acc.currentPage,
					...window[model],
				}
				return { ...searchProps }
			}

			case modelTypes.productAttributes: {
				return {
					...acc,
					productAttributes: window[model],
				}
			}

			case modelTypes.productSpecifications: {
				return {
					...acc,
					productSpecifications: {
						groups: window[model],
					},
				}
			}

			case modelTypes.productsToCompare:
				return { ...acc, productsToCompare: window[model] }

			case modelTypes.newProducts: {
				return {
					...acc,
					newProducts: window[modelTypes.initialState]?.properties?.newProducts,
				}
			}

			case modelTypes.homepageProducts: {
				return { ...acc, homepageProducts: window[model] }
			}

			case modelTypes.bestSellingProducts: {
				return { ...acc, bestSellingProducts: window[model] }
			}

			// Homepage Categories
			case modelTypes.homepageCategories: {
				return { ...acc, homepageCategories: window[model] }
			}

			// Homepage Bestsellers
			case modelTypes.homepageSlider:
				return { ...acc, homepageSlider: window[model] }

			// Homepage News
			case modelTypes.homepageNews:
				return { ...acc, homepageNews: window[model] }

			// Homepage Polls
			case modelTypes.homepagePolls:
				return { ...acc, homepagePolls: window[model] }

			case modelTypes.homepageTopic:
				return { ...acc, homepageTopic: window[model] }

			// Catalog settings
			case modelTypes.catalogSettings:
				return { ...acc, catalogSettings: window[model] }

			// Navbar Languages
			case modelTypes.navbarLanguages:
				return { ...acc, navbarLanguages: window[model] }

			// Navbar Header Links
			case modelTypes.navbarHeaderLinks:
				return { ...acc, navbarHeaderLinks: window[model] }

			case modelTypes.manufacturers: {
				return {
					...acc,
					manufacturers: window[model],
				}
			}

			case modelTypes.addToCart:
				// Just take the full product for now

				return {
					...acc,

					// props for layouting in WUI
					...window[modelTypes.productDetails].addToCart,

					// props to pass back to theme
					id: window[modelTypes.productDetails].id,
					defaultPictureModel: window[modelTypes.productDetails].defaultPictureModel,
					seName: window[modelTypes.productDetails].seName,
					productPrice: window[modelTypes.productDetails].productPrice,
					sku: window[modelTypes.productDetails].sku,
					quantity: 1,
				}

			// Navbar Menu
			case modelTypes.navbarMenu:
				return { ...acc, navbarMenu: window[model] }

			// Navbar Search Box
			case modelTypes.navbarSearchBox:
				return { ...acc, navbarSearchBox: window[model] }

			// Navbar Vat
			case modelTypes.navbarVat:
				return { ...acc, navbarVat: window[model] }

			// Navbar Logo
			case modelTypes.navbarLogo:
				return { ...acc, navbarLogo: window[model] }

			// Navbar Motivators
			case modelTypes.navbarMotivators:
				return { ...acc, navbarMotivators: window[model] }

			case modelTypes.categoryCurrentPage:
				return { ...acc, ...window[model] }

			case modelTypes.homePage:
				return { ...acc, homePage: window[model] }

			case modelTypes.accountPage:
				return { ...acc, accountPage: window[model] }

			case modelTypes.productDetails:
				return { ...acc, productDetails: window[model] }

			case modelTypes.extendedDescription:
				return { ...acc, extendedDescription: window[model] }

			case modelTypes.productDocuments:
				return { ...acc, productDocuments: window[model] }

			case modelTypes.productVideo:
				return { ...acc, productVideo: window[model] }

			case modelTypes.recentlyViewedProducts:
				return { ...acc, recentlyViewedProducts: window[model] }

			case modelTypes.catalogProductsModel: {
				return { ...acc, ...window[model] }
			}

			case modelTypes.cartSettings: {
				return { ...acc, cartSettings: window[model] }
			}

			case modelTypes.orderSettings: {
				return { ...acc, orderSettings: window[model] }
			}

			case modelTypes.routes: {
				return { ...acc, routes: window[model] }
			}

			default:
				break
		}

		return acc
	}, {})

	return {
		...props,
	}
}

export default useSSR
